import { Directive, HostBinding, Input } from '@angular/core';
import {
  ThasEventType,
  ThasTooLUseEventAction,
} from '@thiememeulenhoff/analytics-service-client';
import { AttributeDirective } from './attribute.directive';

@Directive({
  selector: '[thasToolUse]',
})
export class ToolUseDirective extends AttributeDirective {
  protected readonly type = ThasEventType.ToolUse;

  @Input('thasToolUse')
  @HostBinding('attr.data-thas-tooluse')
  public value?: ThasTooLUseEventAction;
}
